import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import { Table } from 'semantic-ui-react'
import {getChartColors, minutesToHuman} from '../../Helpers'
import {Pie, Bar} from 'react-chartjs-2';
import PropTypes from 'prop-types';
class ReportCommessePrevisionale extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items:[],
            pieData: {},
            barData: {},
            total: 0,
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
        this.loadData(this.props.commessa.idCommessa, this.props.dataStart, this.props.dataEnd);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.commessa !== this.props.commessa || nextProps.dataStart !== this.props.dataStart || nextProps.dataEnd !== this.props.dataEnd)
        {
            this.loadData(nextProps.commessa.idCommessa, nextProps.dataStart, nextProps.dataEnd);
        }
    }

    loadData(idCommessa, dataStart, dataEnd) {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportCommessePrevisionale(idCommessa, dataStart, dataEnd).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        pieData: this.createPieData(data.items),
                        barData: this.createBarData(data.items, '% ore lavorate, reali e previsionali', 8),
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    createPieData(items)
    {
        let labels = [];
        let datas = [];
        for(let i=0; i<items.length; i++){

            labels.push("Anno " + items[i].anno);
            datas.push(items[i].percOre);

        }

        const data = {
            labels: labels,
            datasets: [{
                data: datas,
                backgroundColor: getChartColors(),
                hoverBackgroundColor: getChartColors(),
            }]
        };
        return data;
    }

    createBarData(items, titolo, colore)
    {
        let labels = [];
        let datas = [];
        let colors = [];
        for(let i=0; i<items.length; i++){
            labels.push(items[i].anno);
            datas.push(items[i].percOre);
            if (items[i].tipo == "R"){
                colors.push("#00EE00");
            }
            else{
                colors.push("#EE0000");
            }
        }

        const data = {
            labels: labels,
            datasets: [{
                label: titolo,
                data: datas,
                borderWidth: 1,
                backgroundColor: colors,
                hoverBackgroundColor: getChartColors(1)[colore],
            }]
        };
        return data;
    }
    


    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }
        let i = 0;

        const chartPie = this.props.viewCharts ? <Pie data={this.state.pieData} options={{legend: {position: 'bottom'}}}/> : null
        const chartBar = this.props.viewCharts ? <Bar data={this.state.barData} options={{legend: {display: false}}}/> : null
        
        const tableClass = this.props.viewCharts ? "eigth wide column" : "sixteen wide column"
        const chartClass = this.props.viewCharts ? "eigth wide column" : ""

        return (<div className="ui two columns grid">
            {/*Qui ci va la tabella*/}
            <div className={tableClass}>

                <Table celled>
                    <Table.Body>
                            <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                                <Table.Cell textAlign='center'>
                                    Anno
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Durata Totale (ore)
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Percentuale
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Reale/Previsionale
                                </Table.Cell>
                            </Table.Row>
                        {
                            this.state.items.map((item) => {
                                let rcolor = 'black';
                                if(item.tipo==="P"){
                                    rcolor = 'red';
                                }
                                return <Table.Row key={i++} style={{color: rcolor}}>
                                    <Table.Cell  textAlign='center'>{item.anno}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.oreSvolte}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.percOre}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.tipo}</Table.Cell>
                                </Table.Row>
                            })}
                    </Table.Body>
                    <Table.Footer>
                    </Table.Footer>
                </Table>

            </div>
            {/*Qui ci va la torta*/}
            <div className={chartClass}>
                {chartBar}
                <br/>
                {chartPie}
            </div>
            {loader}
        </div>)
    }
}

ReportCommessePrevisionale.PropTypes = {
    commessa: PropTypes.object.isRequired,
    dataStart: PropTypes.string.isRequired,
    dataEnd: PropTypes.string.isRequired,
    viewCharts: PropTypes.bool.isRequired,
}


ReportCommessePrevisionale.defaultProps = {
    viewCharts: false,
};

export default ReportCommessePrevisionale;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommessePrevisionale.js
 **/